<template>
    <div>
        <div class="tw:tracking-wide">
            {{ titel }}
        </div>
        <div class="tw:text-2xl">
            {{ status }}
        </div>
    </div>
</template>

<script setup lang="ts">
defineProps<{
    titel: string;
    status: number;
}>();
</script>
